import React from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  IconButton,
  Link,
  Divider,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { useMediaQuery } from "react-responsive";
import { COLORS } from "../../constants";
import useSystemHook from "./../../hooks/SystemHook";

const ContactUs = () => {
  const { isMobile, isTablet, isDesktop } = useSystemHook();
  const contactInfo = [
    {
      label: "Phone",
      icon: <PhoneIcon fontSize="small" />,
      link: "tel:+27117475200",
      text: "(+27) 11 747 5200",
    },
    {
      label: "WhatsApp",
      icon: <WhatsAppIcon fontSize="small" />,
      link: "https://wa.link/ov1mre",
      text: "083 654 5120",
    },
    {
      label: "Email",
      icon: <EmailIcon fontSize="small" />,
      link: "mailto:info@argusmotoring.co.za",
      text: "info@argusmotoring.co.za",
    },
    {
      label: "Operating Hours",
      icon: <ScheduleIcon fontSize="small" />,
      link: null, // No link for Operating Hours
      text: "Mon to Thurs: 8:00 AM - 4:30 PM\nFri: 8:00 AM - 1:30 PM\nSaturday & Sunday: Closed",
    },
  ];

  const addressSection = (
    <Box sx={{ my: 3 }}>
      <Typography
        variant="body2"
        sx={{
          color: COLORS.lightText,
          mb: 2,
          fontSize: isMobile ? "var(--font-size-xxs)" : "var(--font-size-xs)",
        }}
      >
        Contact us today for quality automotive solutions you can depend on.
      </Typography>
      <Link
        href="https://goo.gl/maps/RbgTFmVshrD2WJYu8"
        target="_blank"
        rel="noopener"
        variant="body2"
        sx={{
          textDecoration: "none",
          color: "primary.main",
          fontWeight: 500,
          fontSize: isMobile ? "var(--font-size-xxs)" : "var(--font-size-xs)",
        }}
      >
        28 Great North Road, Brentwood Park, 1501, South Africa
      </Link>
    </Box>
  );

  const contactSection = (
    <>
      {contactInfo.map((info) => (
        <Box
          key={info.label}
          sx={{ display: "flex", alignItems: "center", mb: 1 }}
        >
          <IconButton sx={{ mr: 1 }}>{info.icon}</IconButton>
          <Link
            href={info.link}
            variant="body2"
            target={info.label === "WhatsApp" ? "_blank" : undefined}
            rel={info.label === "WhatsApp" ? "noopener noreferrer" : undefined}
            sx={{
              textDecoration: "none",
              color: COLORS.darkText,
              whiteSpace: info.link ? "normal" : "pre-line",
              fontSize: isMobile
                ? "var(--font-size-xxs)"
                : "var(--font-size-xs)",
            }}
          >
            {info.text}
          </Link>
        </Box>
      ))}
    </>
  );

  const mapEmbed = (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        pb: "56.25%",
        height: "100%",
      }}
    >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.5795860208736!2d28.2970668!3d-26.1452474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9516007af0406f%3A0xccf786c2e19b2866!2sArgus%20Motor%20Company!5e0!3m2!1sen!2sza!4v1715939532944!5m2!1sen!2sza"
        width="100%"
        height="100%"
        style={{ border: 0, position: "absolute", top: 0, left: 0 }}
        allowFullScreen=""
        loading="lazy"
        title="Argus Location"
      ></iframe>
    </Box>
  );

  return (
    <>
      <Typography
        sx={{
          paddingLeft: 0,
          backgroundColor: "none",
          fontSize: isMobile ? "var(--font-size-l)" : "var(--font-size-xl)",
          fontWeight: 500,
          my: 4,
        }}
      >
        Contact Us
      </Typography>
      <Grid
        container
        spacing={4}
        sx={{ flexDirection: { xs: "row", md: "row" } }}
      >
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              padding: 4,
              backgroundColor: COLORS.white,
              border: `1px solid ${COLORS.border}`,
              borderRadius: "2px",
              height: "100%",
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: isMobile
                  ? "var(--font-size-xs)"
                  : "var(--font-size-m)",
                mb: 2,
              }}
            >
              Get in touch
            </Typography>
            <Divider sx={{ borderColor: COLORS.border, mb: 2 }} />
            {addressSection}
            {contactSection}
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          {mapEmbed}
        </Grid>
      </Grid>
    </>
  );
};

export default ContactUs;
